import { EMAILS_CHANNELS_AND_RESOURCES } from 'src/data/performance/const';

export const GENERIC_RESOURCE = 'generic_resource';

export const EMAIL_CSV_RESOURCE = {
  emailSubjectLineCsvResource: 'email_subject_csv_resource',
  emailPromotionCsvResource: 'email_promotion_csv_resource',
  emailColdCsvResource: 'email_cold_csv_resource',
};

//TODO - CAN BE REMOVED?
export const RESOURCE_DOCUMENT = {
  ...EMAIL_CSV_RESOURCE,
  emailCsvResource: 'email_csv_resource',
  googleDocs: 'google_docs',
};

export const EMAIL_CSV_RESOURCES = Object.values(EMAIL_CSV_RESOURCE);

export const RESOURCE_TYPE = {
  ...EMAIL_CSV_RESOURCE,
};

export const RESOURCE_TYPES = Object.values(RESOURCE_TYPE);

export const isEmailCsvResourceDocument = (resourceDocument) =>
  EMAIL_CSV_RESOURCES.includes(resourceDocument);

export const RESOURCE_DOCUMENT_PROPS = {
  [RESOURCE_DOCUMENT.emailCsvResource]: {
    label: 'Email performance report',
  },
  [RESOURCE_DOCUMENT.emailSubjectLineCsvResource]: {
    label: 'Email - subject line performance report',
  },
  [RESOURCE_DOCUMENT.emailPromotionCsvResource]: {
    label: 'Email - promotion performance report',
  },
  [RESOURCE_DOCUMENT.emailColdCsvResource]: {
    label: 'Email - cold performance report',
  },
  [RESOURCE_DOCUMENT.googleDocs]: {
    label: 'Google docs',
  },
};

export const RESOURCE_TAG = {
  general: 'general',
  amazon: 'amazon',
  trustpilot: 'trustpilot',
  homepage: 'home_page',
  productPage: 'product_page',
  landingPage: 'landing_page',
  competitors: 'competitors',
  thoughtLeadership: 'thought_leadership',
  blogPost: 'blog_post',
};

export const RESOURCE_TAG_PROPS = {
  [RESOURCE_TAG.general]: {
    label: 'General',
  },
  [RESOURCE_TAG.amazon]: {
    label: 'Amazon reviews',
  },
  [RESOURCE_TAG.trustpilot]: {
    label: 'Trustpilot reviews',
  },
  [RESOURCE_TAG.homepage]: {
    label: 'Homepage',
  },
  [RESOURCE_TAG.productPage]: {
    label: 'Product information',
  },
  [RESOURCE_TAG.landingPage]: {
    label: 'Landing page',
  },
  [RESOURCE_TAG.competitors]: {
    label: 'Competitor',
  },
  [RESOURCE_TAG.thoughtLeadership]: {
    label: 'Thought leadership',
  },
  [RESOURCE_TAG.blogPost]: {
    label: 'Blog post',
  },
};

export const getResourceTagLabel = (tag) => {
  return RESOURCE_TAG_PROPS[tag]?.label || tag;
};

export const RESOURCE_CONTENT_TYPE = {
  url: 'url',
  pdf: 'pdf',
  img: 'image',
};

export const RESOURCE_CONTENT_TYPE_PROPS = {
  [RESOURCE_CONTENT_TYPE.url]: {
    label: 'Webpage',
  },
  [RESOURCE_CONTENT_TYPE.pdf]: {
    label: 'Document',
    description: 'Supports PDF, doc, docx up to 20MB',
    acceptedFileType: {
      'text/pdf': ['.pdf'],
    },
  },
  [RESOURCE_CONTENT_TYPE.img]: {
    label: 'Image',
    description: 'Max image size 20MB (JPEG, JPG, PNG only)',
    acceptedFileType: {
      'image/jpg': [],
      'image/jpeg': [],
      'image/png': [],
    },
  },
};

export const RESOURCE_STATUS = {
  active: 'active',
  processing: 'processing',
  archived: 'archived',
};

export const getResourceDocumentLabel = (document) => RESOURCE_DOCUMENT_PROPS[document]?.label;

export const getIsEmailChannel = (channel) => EMAILS_CHANNELS_AND_RESOURCES.includes(channel);
export const getIsResource = (channel) => RESOURCE_TYPES.includes(channel);

export const getCreatedResourceMessage = (resource, availableResources) => {
  return `A resource was successfully added to Anyword${
    availableResources > -1 ? ` (${availableResources - 1} resources left)` : ''
  }:\n"${resource?.name || resource?.url}"`;
};
